var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4191 11.2353V9C23.4191 7.89543 22.5237 7 21.4191 7H5.30148C4.19691 7 3.30148 7.89543 3.30148 9V18.7647C3.30148 19.8693 4.19691 20.7647 5.30148 20.7647H6.47795",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6544 14.4118V13.2353C27.6544 12.1307 26.759 11.2353 25.6544 11.2353H9.53677C8.4322 11.2353 7.53677 12.1307 7.53677 13.2353V23C7.53677 24.1046 8.4322 25 9.53677 25H25.6544C26.759 25 27.6544 24.1046 27.6544 23V20.2353",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4486 17.3235C28.4486 17.7621 28.093 18.1177 27.6544 18.1177C27.2159 18.1177 26.8603 17.7621 26.8603 17.3235C26.8603 16.885 27.2159 16.5294 27.6544 16.5294C28.093 16.5294 28.4486 16.885 28.4486 17.3235Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.52f0607a53785b0ad9394fd656359bdf.svg";
export { ForwardRef as ReactComponent };